export var OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
// ClassName for links in the receiver side. This is for reply with original thread or forward.
export var X_OWA_AUTO_LINKS_CLASSNAME = 'x_OWAAutoLink';
export var ANCHOR_TAG_NAME = 'a';
export var IMG_TAG_NAME = 'img';
export var SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME = 'originalsrc';
//# sourceMappingURL=constants.js.map